import React, { ChangeEventHandler } from 'react';

import FormInvalid from './FormInvalid';

export type KeyValuePairs = [string | number, string | number][];

export type SelectOptions = { [value: string]: string | number } | KeyValuePairs;

const getKeyValuePairs = (options: SelectOptions): KeyValuePairs =>
    Array.isArray(options) && Array.isArray(options[0]) ? options : Object.entries(options);

type Props = Readonly<{
    field: string;
    value: string | number;
    label: string | JSX.Element;
    options: SelectOptions;
    error: string;
    handleChange: ChangeEventHandler<HTMLSelectElement>;
    required?: boolean;
    disabled?: boolean;
    showLabel?: boolean;
    nullCaption?: string;
}>;

/**
 * For unprepared options data use ./AdvancedSelect.tsx
 */
function Select({
    field,
    value,
    label,
    options,
    error,
    handleChange,
    required = false,
    disabled = false,
    showLabel = true,
    nullCaption,
}: Props) {
    const hasError = (error ?? false) !== false;

    return (
        <div className="form-group">
            {showLabel && (
                <label htmlFor={field}>
                    {label} {required ?? <span className="text-danger text-sm">*</span>}
                </label>
            )}
            <select
                id={field}
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                name={field}
                value={value}
                onChange={handleChange}
                required={required}
                disabled={disabled}
            >
                {!required && (
                    <option key={-1} value="">
                        {nullCaption ?? '\u2014'}
                    </option>
                )}
                {getKeyValuePairs(options).map(([key, val]) => (
                    <option key={key} value={key}>
                        {val}
                    </option>
                ))}
            </select>
            {hasError && <FormInvalid message={error} />}
        </div>
    );
}

export default Select;
